
import { computed, defineComponent } from '@nuxtjs/composition-api'
import ElementSnapSlider from '~/components/element/elementSnapSlider.vue'
import ElementHeadline from '~/components/element/elementHeadline.vue'

export default defineComponent({
  components: { ElementHeadline, ElementSnapSlider },
  props: ['color', 'itemType'],
  setup(props) {
    const itemTypeColorSets: { [key: string]: { [key: string]: string } } = {
      weddingRing: {
        w: 'A-1282-1',
        d: 'A-1282-4',
        g: 'A-1282-2',
        r: 'A-1282-5',
        e: 'A-1282-3',
        x: 'A-1282-1',
      },
      engagementRing: {
        w: 'A-1488-1',
        d: 'A-1488-1',
        g: 'A-1488-2',
        r: 'A-1488-3',
        e: 'A-1488-4',
        x: 'A-1488-37',
      },
      memoire: {
        w: 'A-2234-1',
        d: 'A-2234-5',
        g: 'A-2234-2',
        r: 'A-2234-4',
        e: 'A-2234-3',
        x: 'A-2234-11',
      },
      earing: {
        w: 'A-2063-5',
        d: 'A-2063-5',
        g: 'A-2063-6',
        r: 'A-2063-7',
        e: 'A-2063-8',
        x: 'A-2063-5',
      },
      collier: {
        w: 'A-2060-6',
        d: 'A-2060-6',
        g: 'A-2060-5',
        r: 'A-2060-7',
        e: 'A-2060-8',
        x: 'A-2060-6',
      },
      bracelet: {
        w: 'A-1871-3',
        d: 'A-1871-3',
        g: 'A-1871-2',
        r: 'A-1871-4',
        e: 'A-1871-1',
        x: 'A-1871-3',
      },
    }

    const mainColor = computed(() => {
      const uniqueColors: string[] = Array.from(new Set(props.color.split('')))

      const colorPriority: string[] = ['W', 'D', 'G', 'R', 'E', 'X']

      for (const colorIdx in colorPriority) {
        if (uniqueColors.includes(colorPriority[colorIdx])) {
          return colorPriority[colorIdx].toLowerCase()
        }
      }
      return 'W'.toLowerCase()
    })

    /*
      Images Host
    */

    const imagesHost: string = process.env.imagesHost as string

    return { mainColor, itemTypeColorSets, imagesHost }
  },
})
